module.exports = 'ui-ng-delegate';

/** @class Delegate */
angular.module('ui-ng-delegate', []).constant('DelegateDefinition', function DelegateDefinition(id, handle) {

  /**
   * @what the core of a delegate object; which only needs delegation methods
   */
  var _id = id;
  this._handle = handle;

  /**
   * specific delegate
   * @memberof Delegate
   */
  this.id = function getIdDelegate() {
    return _id;
  };

  /**
   * get handle
   * @memberof Delegate
   */
  this.getHandle = function getHandleDelegate() {
    return this._handle;
  };

  /**
   * create a new delegate and assign a handle
   * @memberof Delegate
   */
  this.handle = function handleDelegate(handle) {
    return (_.isUndefined(handle))
      ? this.getHandle()
      : assignTo(_.clone(this), handle);
  };

  /**
   * @deprecated
   */
  this.restrictTo = this.handle;

  /**
   * assign handle name for grouped messages
   * @memberof Delegate
   */
  var assignTo = function assignToDelegate(delegate, h) {
    
    delegate._handle = h;
    return delegate;
  };

}).provider('DelegateActiveModel', function DelegateActiveModel() {

  var model = this.model = {
    activeComponents: {}
  };

  this.$get = function DelegateActiveModelDefinition() {
    return {
      model: model
    };
  };

}).provider('DelegateController', function DelegateController(DelegateActiveModelProvider) {

  /**
   * @what defines one specific delegate, constructor for a delegate adding methods and core delegate services
   */
  var buildSpecificDelegateObject = function buildSpecificDelegateObject(service, configuration, DelegateDefinition) {
    return _.merge(service, (new DelegateDefinition(configuration.uniqueComponent, undefined)));
  };

  var applyMethodsToDelegate = function applyMethodsToDelegate($q, service, configuration) {
    _.each(configuration.vocabulary, function (methodsNameIsIgnored, methodName) {
      (function (service) {
        service[methodName] = function () {

          var deferred = $q.defer();
          var expectedReceiveMessages = DelegateActiveModelProvider.model.activeComponents[configuration.uniqueComponent];
          var returnValues = [];

          var handle = this.getHandle();
          var message = (!handle)
            ? 'eabui.' + this.id() + '.' + methodName
            : 'eabui.' + this.id() + '.' + handle + '.' + methodName;

          this._$rootScope.$$listeners[message + '.receive'] = [];
          this._$rootScope.$on(message + '.receive', function (event, returnValue) {

            var received;

            if (returnValue && returnValue.promise) {
              received = returnValue.promise;
            }
            else if (returnValue && _.isFunction(returnValue.then)) {
              received = returnValue;
            }
            else {
              received = $q.defer();
              received.resolve(returnValue);
              received = received.promise;
            }

            returnValues.push(received);

            if (returnValues.length >= expectedReceiveMessages) {
              $q.all(returnValues).then(function () {
                deferred.resolve.apply(deferred, Array.prototype.slice.call(arguments));
              });
            }

          });

          this._$rootScope.$broadcast(message, Array.prototype.slice.call(arguments));
          return deferred.promise;

        };
      }(this));
    }, service);
  };

  var applyRootscopeToService = function applyRootscopeToService(service, $rootScope) {
    service._$rootScope = $rootScope;
  };

  return {
    $get: function (DelegateDefinition, $rootScope, $q) {
      return function createDelegate(service, configuration) {
        buildSpecificDelegateObject(service, configuration, DelegateDefinition);
        applyMethodsToDelegate($q, service, configuration);
        applyRootscopeToService(service, $rootScope);
      };
    }
  }

}).provider('DelegateResponder', function DelegateResponder() {

  var _$rootScope;

  var standardRemapResponseFunction = function standardRemapResponseFunction(scope) {
    return function (responseFn) {
      return (function (messageName) {
        return (function () {

          var rtn = responseFn.apply(scope, _.flatten(Array.prototype.slice.call(arguments)));

          if (messageName) {
            _$rootScope.$emit(messageName + '.receive', rtn);
          }

          return rtn;
        });
      });
    };
  };

  var informedRemapResponseFunction = function informedRemapResponseFunction(scope, element, attrs) {

    var linkerParameters = [scope, element, attrs];

    return function (responseFn) {
      return (function (messageName) {
        return (function () {

          var rtn = responseFn.apply(scope, linkerParameters.concat(_.flatten(Array.prototype.slice.call(arguments))));

          if (messageName) {
            _$rootScope.$emit(messageName + '.receive', rtn);
          }

          return rtn;
        });
      });
    };
  };

  var applyLocalListeners = function applyLocalListeners($scope, configuration, responseFn, responseKey) {
    var messageName = 'eabui.' + configuration.uniqueComponent + '.' + configuration.handle + '.' + responseKey;
    if (!!configuration.handle) {
      $scope.$on(messageName, responseFn(messageName));
    }
  };

  var applyGlobalListeners = function applyGlobalListeners($scope, configuration, responseFn, responseKey) {
    var messageName = 'eabui.' + configuration.uniqueComponent + '.' + responseKey;
    $scope.$on(messageName, responseFn(messageName));
  };

  var applyDirectMethodCall = function applyDirectMethodCall($scope, configuration, responseFn, responseKey) {

    var responseFnCall = responseFn();

    $scope[responseKey] = function () {
      return responseFnCall(null, Array.prototype.slice.call(arguments));
    }
  };

  this.$get = function ($rootScope, DelegateActiveModel) {

    var createStandardDelegate = function createStandardDelegate($scope, attrs, configuration, remapResponseFunction) {

      // TODO remove if-statement when next DEPRECATED message is removed
      if (configuration !== undefined) {
        configuration.handle = attrs.handle;
      }

      // DEPRECATED remove eventually, this will allow the attrs to stay on the configuration which could cause memory leaks
      else if (configuration === undefined) {
        configuration = attrs;
        configuration.handle = configuration.attrs.handle;
      }

      DelegateActiveModel.model.activeComponents[configuration.uniqueComponent] = DelegateActiveModel.model.activeComponents[configuration.uniqueComponent] || 0;
      DelegateActiveModel.model.activeComponents[configuration.uniqueComponent] += 1;

      $scope.$on('$destroy', function () {
        DelegateActiveModel.model.activeComponents[configuration.uniqueComponent] -= 1;
      });

      _.each(configuration.vocabulary, function (responseFn, responseKey) {
        (function ($scope) {

          responseFn = remapResponseFunction(responseFn);
          applyLocalListeners($scope, configuration, responseFn, responseKey);
          applyGlobalListeners($scope, configuration, responseFn, responseKey);
          applyDirectMethodCall($scope, configuration, responseFn, responseKey);

        }(this));
      }, $scope);

    };

    var createInformedDelegate = function createInformedDelegate(configuration, linkerFn) {

      return function (scope, element, attrs) {
        createStandardDelegate(scope, attrs, configuration, informedRemapResponseFunction(scope, element, attrs));
        return linkerFn.apply(this, Array.prototype.slice.call(arguments));
      }
    };

    /**
     * we need $rootScope to $emit, so there is no tag chaining
     */
    _$rootScope = $rootScope;

    /**
     * scenario 1:
     * - p1: $scope
     * - p2: configuration
     *
     * scenario 2:
     * - p1: $scope
     * - p2: attrs
     * - p3: configuration
     *
     * scenario 3:
     * - p1: configuration
     * - p2: linkerFn
     *
     * prefer (scenario 3)
     */
    return function createDelegateResponse(p1, p2, p3) {
      if (_.isFunction(p2)) {
        return createInformedDelegate(p1, p2);
      }
      else {
        return createStandardDelegate(p1, p2, p3, standardRemapResponseFunction(p1));
      }
    };
  };

});



// WEBPACK FOOTER //
// core.js